import React from 'react'
import styled from 'styled-components'

import { GetCustomerCartQuery } from '../../graphql/magento'
import { cartSubtotal, salesTax, shippingTotal, taxType } from '../../utils/priceTools'
import CartAppliedCoupons from './CartAppliedCoupons'
import CartAppliedRebates from './CartAppliedRebates'
import CartRetailDeliveryFee from './CartRetailDeliveryFee'
import CartSummaryRow from './CartSummaryRow'

const StyledSectionHeader = styled.h5`
  font-size: 14px;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 17px;
`

export interface CartSummaryProps {
  className?: string
  cart: NonNullable<GetCustomerCartQuery['customerCart']>
  summaryVisible: boolean
}

const CartSummary: React.FC<CartSummaryProps> = ({ className, cart, summaryVisible }) => {
  const { prices, items } = cart

  if (!summaryVisible || !cart) {
    return null
  }

  return (
    <div className={className}>
      <StyledSectionHeader>SUMMARY</StyledSectionHeader>
      <CartSummaryRow>
        <div>Subtotal:</div>
        <div>{cartSubtotal({ items, prices })}</div>
      </CartSummaryRow>
      <CartSummaryRow>
        <div>Shipping:</div>
        <div>{shippingTotal({ shippingAddresses: cart.shipping_addresses, items })}</div>
      </CartSummaryRow>
      <CartSummaryRow>
        <div>{`Sales Tax${taxType({ prices })}:`}</div>
        <div>{salesTax({ prices })}</div>
      </CartSummaryRow>
      <CartRetailDeliveryFee cart={cart} />
      <CartAppliedCoupons cart={cart} />
      <CartAppliedRebates cart={cart} />
    </div>
  )
}

const StyledCartSummary = styled(CartSummary)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.coolGray.cool250};
  // top padding adjusts spacing between summary and promo code components
  padding: 10px 0;
  margin-bottom: 5px;
`

export default StyledCartSummary
